import {postData, sendRequest} from "./request";
import {store} from "../store";
import axios from "axios";

const configRequests = {};

const configs = {};

export const getFieldConfig = async (config, field) => {
    if (!config.fielddefs[field]) {
        if (config.target) {
            config = await getComponentConfig(config.target);
            if (config.fielddefs[field]) {
                return config;
            } else {
                return await this.loadConfig(config, field);
            }
        }
        // TODO adapter
        /* else if (config.objects) {
            for (let object in config.objects) {
                config = await getComponentConfig(object);
                if (config.fielddefs[field]) {
                    return config;
                } else {
                    return await this.loadConfig(config, field);
                }
            }
        }*/
    } else {
        return config;
    }
}

export const getComponentConfig = (componentName) => {
    let abort = false;
    let request = null;
    const r = new Promise((resolve, reject) => {
        //const editors = store.getState().editors;
        let config = configs[componentName];// || (editors[componentName] || {}).componentConfig;
        if (!config) {
            request = configRequests[componentName];
            if (!request) {
                request = configRequests[componentName] = postData({
                    action: componentName + ".getComponentConfig"
                }, {}, {showError: false});
            }
            request.then((componentConfig) => {
                if (abort) {
                    reject({});
                }
                delete configRequests[componentName];
                if (componentConfig.componentname) {
                    configs[componentName] = componentConfig;
                    !abort && resolve(JSON.parse(JSON.stringify(componentConfig)));
                } else {
                    !abort && reject(componentConfig);
                }
            });
            request.catch((e) => {
                if (e instanceof axios.Cancel || abort) {
                    reject({});
                }
                delete configRequests[componentName];
                !abort && reject(e);
            });
        } else {
            !abort && resolve(JSON.parse(JSON.stringify(config)));
        }
    });
    r.abort = () => {
        abort = true;
        request && request.abort();
    };
    return r;
};

export const saveComponent = (componentName, data, action = null) => {
    let aborted = false;
    const p = new Promise(async (resolve, reject) => {
        try {
            const componentConfig = await getComponentConfig(componentName);
            action = action || (!data[componentConfig.idfield] ? "create" : "update");

            let requestData = {
                action: componentName + "." + action,
                data
            };
            resolve(await postData(requestData));
        } catch (e) {
            reject(e);
        }
    });
    p.abort = () => {
        aborted = true;
    };
    return p;
};

export const deleteComponent = (componentName, data) => {
    let requestData = {
        action: componentName + ".delete",
        ...data
    };
    return postData(requestData);
};

export const loadComponentById = (componentName, id, view = "default", params = {}) => {
    let aborted = false;
    let request = null;
    const p = new Promise((resolve, reject) => {
        request = getComponentConfig(componentName);
        request.then((componentConfig) => {
            if (aborted) {
                reject({});
            }
            request = sendRequest({
                option: componentName,
                view,
                [componentConfig.idfield]: id,
                ...params
            });
            request.then((response) => {
                if (aborted) {
                    reject({});
                }
                resolve(response);
            });
            request.catch((e) => {
                reject(e);
            });
        });
        request.catch((e) => {
            reject(e);
        });
    });
    p.abort = () => {
        aborted = true;
        request && request.abort();
    };
    return p;
};

export const loadComponent = (componentName, params, view = "default") => {
    let aborted = false;
    let request = null;
    const p = new Promise((resolve, reject) => {
        if (aborted) {
            reject({});
        }
        request = sendRequest({
            option: componentName,
            view,
            ...params
        });
        request.then((response) => {
            if (aborted) {
                reject({});
            }
            resolve(response);
        });
        request.catch((e) => {
            reject(e);
        });
    });
    p.abort = () => {
        aborted = true;
        request && request.abort();
    };
    return p;
};

export const createComponent = (componentName, params, view = "default") => {
    return postData({
        action: componentName + ".create",
        view,
        ...params
    });
};